export default (rangeSelectorRef, show) => {
    var _a, _b;
    const sliderMarkers = (_b = (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.instance.element()) === null || _b === void 0 ? void 0 : _b.querySelectorAll(".slider-marker");
    if (!sliderMarkers)
        return;
    sliderMarkers.forEach(m => {
        if (show) {
            m.classList.remove("d-none");
        }
        else {
            m.classList.add("d-none");
        }
    });
};
